module.exports = __webpack_public_path__ + "static/media/neumaticos.2ad60b2d.png";